import {WaypointDispatcher} from '../../../../hooks/useWaypoints';
import React from 'react';
import WritableWaypointPopup from './WritableWaypointPopup';
import NonWritableWaypointPopup from './NonWritableWaypointPopup';

export interface WaypointPopupProps {
    waypoint: Waypoint;
    waypointDispatcher: WaypointDispatcher;
    onWaypointMoveStart: (waypoint: Waypoint, mapboxLayerId: string | undefined) => void;
    onPopupChange: (popup: MapPopup) => void;
    onTrackMoveStart: (trackLocalId: string, mapboxLayerId: string | undefined) => void;
    interaction: MapInteraction;
    mapboxLayerId: string | undefined;
}

export default function WaypointPopup(props: WaypointPopupProps) {
    const {waypoint} = props;

    if (waypoint.properties.writable) {
        return <WritableWaypointPopup {...props} />;
    } else {
        return <NonWritableWaypointPopup {...props} />;
    }
}
